import React from 'react'
import moment from 'moment';

import InlineTextField from '../../components/InlineTextField';
import ModuleItemDeactivator from './ModuleItemDeactivator';
import ModuleItemActivator from './ModuleItemActivator';

const ModuleItem = (props) => {

    const handleGtinChange = (gtin) => {
        props.updateArticleGtin(props.article.gtin, gtin);
    };

    const handleErpIdnoChange = (erpIdno) => {
        return props.updateArticleErpIdno(props.article.gtin, erpIdno);
    };

    const handleNameChange = (name) => {
        return props.updateArticleName(props.article.gtin, name).then();
    };

    const handleVendorArticleNumberChange = (vendorArticleNumber) => {
      return props.updateVendorArticleNumber(props.article.gtin, vendorArticleNumber);
    };

    const renderActivationState = () => {
        if (props.replenishmentActive) {
            return (
                <ModuleItemDeactivator
                    moduleName={props.module.name}
                    gtin={props.article.gtin}
                    deactivateModuleItem={props.deactivateModuleItem}
                />
            )
        } else {
            return (
                <ModuleItemActivator
                    moduleName={props.module.name}
                    gtin={props.article.gtin}
                    deactivationReason={props.deactivationReason}
                    activateModuleItem={props.activateModuleItem}
                />
            )
        }
    };

    const renderCurrentStock = () => {

        if(props.module.unlimitedStock === true) {
            return (
               <span>NOS</span>
            )
        }

        let lastUpdatedAt = '';
        if(props.currentStock.lastUpdatedAt) {
            lastUpdatedAt = moment.utc(props.currentStock.lastUpdatedAt).local().format('DD.MM.YYYY HH:mm:ss');
            lastUpdatedAt = '(' + lastUpdatedAt + ')';
        }

        return (
            <span>
                {props.currentStock.stockQuantity} {lastUpdatedAt}
            </span>
        )
    };

    return (
        <tr>
            <td>{props.module.name}</td>
            <td>{props.article.brand}</td>
            <td><InlineTextField value={props.article.erpIdno} onCommit={handleErpIdnoChange}/></td>
            <td><InlineTextField value={props.article.gtin} onCommit={handleGtinChange}/></td>
            <td><InlineTextField width="100%" value={props.article.name} onCommit={handleNameChange}/></td>
            <td><InlineTextField value={props.article.vendorArticleNumber} onCommit={handleVendorArticleNumberChange}/></td>
            <td>{renderCurrentStock()}</td>
            <td>
                {renderActivationState()}
            </td>
        </tr>
    );
};

export default ModuleItem;



// WEBPACK FOOTER //
// ./src/admin/module/overview/ModuleItem.js